import React, { useState } from "react"

const ServiceFaq: React.FC = () => {

    // Accordion Active Index
    const [active, setActive] = useState<number>(1);

    const toggleAccordion = (index: number) => {
        setActive(active === index ? -1 : index);
    };

    const faqItems = [
        {
            id: 1,
            title: "01. What types of industries do you optimize ?",
            content:
                "We work with manufacturing, automation, logistics, food processing, industrial equipment, and mechanical systems across various sectors.",
        },
        {
            id: 2,
            title: "02. Do you require downtime to perform optimization ?",
            content:
                "In most cases, assessments can be conducted with minimal or no downtime. Any required stoppages are planned carefully to reduce impact on production.",
        },
        {
            id: 3,
            title: "03. Is Industrial Optimization only for large factories ?",
            content:"Not at all. Small and mid-size facilities often benefit the most, as even minor improvements can lead to significant cost savings.",
        },
        {
            id: 4,
            title: "04. Can you optimize existing equipment, or do we need new machines ?",
            content:
                "We prioritize maximizing existing assets. New equipment is only recommended when it provides a clear return on investment.",
        },
        {
            id: 4,
            title: "05. Is this a one-time service or an ongoing partnership ?",
            content:
                "It can be either. Some clients engage us for a single optimization project, while others work with us continuously to improve performance over time.",
        },
        
    ];


    return (
            <div className="service-process-wrap pt-120 pb-125">
                <div className="row mt-none-50 align-items-center">
                    {/* LEFT SIDE ACCORDION */}
                    <div className="col-lg-6 mt-50">
                        <h2 className="details-content-title mb-40">Service process</h2>

                        <div className="service_process_faq">
                            <div className="accordion">
                                {faqItems.map((item) => (
                                    <div className="accordion-item" key={item.id}>
                                        <div
                                            className={`accordion-button ${active === item.id ? "" : "collapsed"
                                                }`}
                                            role="button"
                                            onClick={() => toggleAccordion(item.id)}
                                        >
                                            {item.title}
                                        </div>

                                        <div
                                            className={`accordion-collapse collapse ${active === item.id ? "show" : ""
                                                }`}
                                        >
                                            <div className="accordion-body">
                                                <p className="m-0">{item.content}</p>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>

                    {/* RIGHT SIDE CLICKABLE LIST */}
                    <div className="col-lg-6 mt-50">
                        <ul className="content_layer_group list-unstyled">
                            {faqItems.map((item,index) => (
                                <li
                                    key={item.id}
                                    onClick={() => toggleAccordion(item.id)}
                                    className={active === item.id ? "active" : ""}
                                >
                                    <span>{index + 1}</span>
                                </li>
                            ))}
                        </ul>
                    </div>
                </div>
            </div>
    )
}

export default ServiceFaq;
